import React from 'react';
import UnauthorizedPage from '@/pages/UnauthorizedPage';
import { UserService } from '@/api/user';

interface RolesGateProps {
  roles: string[];
  children: React.ReactNode;
}

export const RolesGate: React.FC<RolesGateProps> = ({ roles, children }) => {
  const { data: user } = UserService.useGetProjectAssignees();

  if (!user) {
    console.error('User is not found.');
    return null;
  }

  // Convert roles to uppercase
  const Roles = roles.map(role => role.toUpperCase());

  if (!Roles.includes(user.user_type.toUpperCase())) {
    return <UnauthorizedPage />;
  }

  return <>{children}</>;
};
